import VueRouter from "vue-router";

// Pages
import Login from "../pages/Login";
import AxiosRequest from '../classes/AxiosRequest';
import It from "../pages/It/It.vue";
import auth from "./auth";
import NewBTPUser from "../pages/admin/Users/NewBTPUser.vue";

/* PUBLIC ROUTES */
const Signup = () => import(/* webpackChunkName: "Signup" */ "../pages/Signup");
const NotFound = () =>
    import(/* webpackChunkName: "NotFound" */ "../pages/errors/404");
const UserInvite = () =>
    import(/* webpackChunkName: "ForgotPassword" */ "../pages/UserInvite");
const ForgotPassword = () =>
    import(/* webpackChunkName: "ForgotPassword" */ "../pages/ForgotPassword");
const PasswordReset = () =>
    import(/* webpackChunkName: "PasswordReset" */ "../pages/PasswordReset");
const PasswordCreate = () =>
    import(/* webpackChunkName: "PasswordCreate" */ "../pages/PasswordCreate");

/* GUARDED ROUTES */
const Dashboard = () =>
    import(/* webpackChunkName: "Dashboard" */ "../pages/dashboard/Dashboard");
const ActivityLog = () =>
    import(/* webpackChunkName: "ActivityLog" */ "../pages/admin/ActivityLog");
const UploadSchoolData = () =>
    import(
        /* webpackChunkName: "UploadSchoolData" */ "../pages/dataupload/Upload"
        );
// Email campaigns
const Campaigns = () =>
    import(
        /* webpackChunkName: "Campaigns" */ "../pages/admin/Campaigns/Campaigns"
        );
const EditCampaigns = () =>
    import(
        /* webpackChunkName: "Campaigns" */ "../pages/admin/Campaigns/EditCampaign"
        );
// Activity Requests
const ActivityRequests = () =>
    import(
        /* webpackChunkName: "ActivityRequests" */ "../pages/user/ActivityRequests"
        );
const NewActivityRequest = () =>
    import(
        /* webpackChunkName: "ActivityRequests" */ "../pages/user/NewActivityRequest"
        );
//SRS
const SrsEntryLanding = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/EntryLanding"
        );
const EditSrsForm = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/FormBuilder/EditSrsForm"
        );
const SrsFormBuilderLanding = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/FormBuilder/FormbuilderLanding"
        );
const NewSrsForm = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/FormBuilder/NewSrsForm"
        );
const SrsLabels = () =>
    import(/* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/Labels");
const SrsLabelsRequest = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/LabelsRequest"
        );
const NewSrsEntry = () =>
    import(/* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/NewEntry");
const SrsReview = () =>
    import(/* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/Review");
const ReviewEntries = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/ReviewEntries"
        );
const SrsLanding = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/admin/Finance/SRS/SrsLanding"
        );
const ItApiManager = () =>
    import(
        /* webpackChunkName: "SRS" */ "../pages/It/ApiManager/ApiManager.vue"
        );
// Admin
const AdminLanding = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/Landing");
const NewRole = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/Roles/NewRole");
const RoleLanding = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/Roles/RoleLanding");
const PermissionLanding = () =>
    import(
        /* webpackChunkName: "Admin" */ "../pages/admin/Permissions/PermissionLanding"
        );
const PermissionNew = () =>
    import(
        /* webpackChunkName: "Admin" */ "../pages/admin/Permissions/PermissionNew"
        );
const RoutePermissions = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/RoutePermissions/RoutePermissions");
const UserAdministration = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/UserAdministration");
const UserAdministrationDetails = () =>
    import(
        /* webpackChunkName: "Admin" */ "../pages/admin/UserAdministrationDetails"
        );
const UserAdministrationRoles = () =>
    import(
        /* webpackChunkName: "Admin" */ "../pages/admin/UserAdministrationRoles"
        );
const NewUser = () =>
    import(/* webpackChunkName: "Admin" */ "../pages/admin/Users/NewUser");
// Website Administration
const WebsiteConfig = () => import(/* webpackChunkName: "Webiste" */ "../pages/webdesigner/Config");
const LoginImages = () =>
    import(/* webpackChunkName: "Webiste" */ "../pages/admin/LoginImages");
const WebDesignerCarousel = () =>
    import(/* webpackChunkName: "Webiste" */ "../pages/webdesigner/Carousel");
const WebDesignerIndex = () =>
    import(/* webpackChunkName: "Webiste" */ "../pages/webdesigner/Index");
const WebDesignerLoginImages = () =>
    import(
        /* webpackChunkName: "Webiste" */ "../pages/webdesigner/LoginImages"
        );
const SideBarManager = () =>
    import(/* webpackChunkName: "Webiste" */ "../pages/admin/SideBarManager");
const Carousel = () =>
    import(/* webpackChunkName: "Webiste" */ "../pages/admin/Carousel");
// ID Cards
const IdCards = () =>
    import(/* webpackChunkName: "IDCards" */ "../pages/id_cards/IdCards");
const DigitalIdManager = () =>
    import(
        /* webpackChunkName: "IDCards" */ "../pages/digitalid/DigitalIdManager"
        );
const DigitalIds = () => import("../pages/digital-ids/DigitalIds");
const DigitalIdsLogs = () => import("../pages/digital-ids/DigitalIdsLogs");
const StudentNotifications = () => import("../pages/digital-ids/StudentNotifications");
const PassDesign = () =>
    import(/* webpackChunkName: "IDCards" */ "../pages/admin/PassDesign");
const PrintBatchIdCards = () =>
    import(
        /* webpackChunkName: "IDCards" */ "../pages/admin/Printing/PrintBatchIdCards"
        );
// Military
const UnitsEditor = () =>
    import(
        /* webpackChunkName: "UnitsEditor" */ "../pages/military/UnitsEditor"
        );
const MilitaryUsers = () =>
    import(
        /* webpackChunkName: "UserList" */ "../pages/military/UserList"
        );
const MilitaryGraduationDates = () =>
    import(
        /* webpackChunkName: "UserList" */ "../pages/military/GraduationDates"
        );
const MilitaryHome = () =>
    import(
        /* webpackChunkName: "Military" */ "../pages/admin/Military/Dashboard"
        );
const MilitaryMF13 = () =>
    import(/* webpackChunkName: "Military" */ "../pages/admin/Military/MF13");
const MilitaryOrders = () =>
    import(/* webpackChunkName: "Military" */ "../pages/admin/Military/Orders");
const MilitarySquare = () =>
    import(/* webpackChunkName: "Military" */ "../pages/admin/Military/Square");
const MilitaryTraineeSearch = () =>
    import(/* webpackChunkName: "Military" */ "../pages/admin/Military/TraineeSearch");
const MilitaryCalendar = () => import("@/pages/admin/Military/Calendar");
// Orders
const CartDetails = () =>
    import(
        /* webpackChunkName: "Orders" */ "../pages/admin/Orders/CartDetails"
        );
const Carts = () =>
    import(/* webpackChunkName: "Orders" */ "../pages/admin/Orders/Carts");
const Discounts = () =>
    import(
        /* webpackChunkName: "Orders" */ "../pages/admin/Orders/DiscountCodes"
        );
// Events Stuff
const Calendar = () =>
    import(/* webpackChunkName: "Events" */ "../pages/scheduler/Scheduler");
const ScheduleReport = () =>
    import(/* webpackChunkName: "Events" */ "../pages/admin/Reports/Schedule");
const ScheduleReports = () =>
    import(
        /* webpackChunkName: "ScheduleReports" */ "../pages/scheduler/ScheduleReports"
        );
// Seniors
const Scheduling = () =>
    import(
        /* webpackChunkName: "Seniors" */ "../pages/admin/Schools/Scheduling"
        );
const Seniors = () =>
    import(/* webpackChunkName: "Seniors" */ "../pages/admin/Schools/Seniors");
const Appointments = () =>
    import(/* webpackChunkName: "Seniors" */ "../pages/seniors/Appointments");
// Reports
const LabelReport = () =>
    import(
        /* webpackChunkName: "Reports" */ "../pages/admin/Reports/LabelReport"
        );
const MonthlyReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Monthly");
const PicturesReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Pictures");
const RetakeReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Retake");
const YearbookApprovalReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/YearbookApproval");
const K11Report = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/K11");
const PrepaidReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Prepaid");
const ReportsLanding = () =>
    import(
        /* webpackChunkName: "Reports" */ "../pages/admin/Reports/ReportsLanding"
        );
const RequestReports = () =>
    import(
        /* webpackChunkName: "Reports" */ "../pages/admin/Reports/RequestReports"
        );
const SalesReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Sales");
const Summaries = () =>
    import(
        /* webpackChunkName: "Reports" */ "../pages/admin/Reports/Summaries"
        );
const YearbookReport = () =>
    import(/* webpackChunkName: "Reports" */ "../pages/admin/Reports/Yearbook");
// Uploads
const SchoolFiles = () =>
    import(
        /* webpackChunkName: "Uploads" */ "../pages/admin/Uploads/FileShare"
        );
const StudentFiles = () =>
    import(/* webpackChunkName: "Uploads" */ "../pages/admin/Uploads/Student");
// HR
const Salphoto = () =>
    import(/* webpackChunkName: "HR" */ "../pages/hr/Salphoto");
const UserTimesheets = () =>
    import(/* webpackChunkName: "HR" */ "../pages/hr/UserTimesheets");
// Data Uploads Manager
const DataUploads = () =>
    import(/* webpackChunkName: "DataUploads" */ "../pages/dataupload/index");
const DataManagerUnderclass = () =>
    import(/* webpackChunkName: "DataManagerUnderclass" */ "../pages/datamanager/Underclass");
const DataManagerSeniors = () =>
    import(/* webpackChunkName: "DataManagerSeniors" */ "../pages/datamanager/Seniors");
//
const DataManagerDataTransfer = () =>
    import(/* webpackChunkName: "DataUploads" */ "../pages/datamanager/DataTransfer");
//
const DynamicPages = () =>
    import(/* webpackChunkName: "Dynamic" */ "../pages/Dynamic");
//
const Shipping = () =>
    import(/* webpackChunkName: "Shipping" */ "../pages/shipping/Shipping");
//
const SmsCenter = () =>
    import(/* webpackChunkName: "SmsCenter" */ "../pages/sms/SendSms.vue");
//
const Messages = () =>
    import(/* webpackChunkName: "Messages" */ "../pages/messages/Index.vue");
//
const OwncloudImageDownloads = () =>
    import(/* webpackChunkName: "Other" */ "../pages/OwncloudImageDownloads");
const FilmViewer = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/FilmViewer");
const Finance = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Finance/Finance");
const NewWiki = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/NewWiki");
const NoritsuJobs = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Noritsu/JobQueue");
const PhotoContest = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/PhotoContest");
const BusinessCards = () =>
    import(
        /* webpackChunkName: "Other" */ "../pages/admin/Schools/BusinessCards"
        );
const Timesheets = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Tools/Timesheets");
const Wiki = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Wiki");
const Ambassadors = () =>
    import(/* webpackChunkName: "Other" */ "../pages/Ambassadors");
const EmailListGenerator = () =>
    import(/* webpackChunkName: "Other" */ "../pages/EmailListGenerator");
const FilmPackageEditor = () =>
    import(
        /* webpackChunkName: "Other" */ "../pages/filmpackage/FilmPackageEditor"
        );
const OwncloudUploadLinks = () =>
    import(/* webpackChunkName: "Other" */ "../pages/OwncloudUploadLinks");
const Profile = () =>
    import(/* webpackChunkName: "Other" */ "../pages/Profile");
const EventProposalResponse = () =>
    import(
        /* webpackChunkName: "Other" */ "../pages/scheduler/EventProposalResponse"
        );
const Scholarships = () =>
    import(/* webpackChunkName: "Other" */ "../pages/Scholarships");
const FilmAnomalies = () =>
    import(/* webpackChunkName: "Other" */ "../pages/schools/FilmAnomalies");
const StudentAssignment = () =>
    import(/* webpackChunkName: "Other" */ "../pages/StudentAssignment");
const StudentAssignmentUrl = () =>
    import(/* webpackChunkName: "Other" */ "../pages/StudentAssignmentUrl");
const StudentLabels = () =>
    import(/* webpackChunkName: "Other" */ "../pages/user/StudentLabels");
const StudentRecords = () =>
    import(/* webpackChunkName: "Other" */ "../pages/user/StudentRecords");
const UserFeedback = () =>
    import(/* webpackChunkName: "Other" */ "../pages/UserFeedback");

const ReportSms = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/ReportSms");
const InvalidShippingAddresses = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/InvalidShippingAddresses");
const YearbookManager = () => import("@/pages/yearbook/YearbookManager");
const YearbookManagerRollover = () => import("@/pages/yearbook/YearbookManagerRollover");
const AdminTools = () => import("@/pages/admin/AdminTools/AdminTools");
const MysqlAuditTriggers = () => import("@/pages/admin/AdminTools/MysqlAuditTriggers");
const PhotoFeedback = () => import("@/pages/photo_feedback/PhotoFeedback");
const NotifyLists = () => import("@/pages/admin/AdminTools/NotifyLists");
const DigitalIdUpdatePhotos = () => import("@/pages/admin/AdminTools/DigitalIdUpdatePhotos");
const DigitalIdMigrate = () => import("@/pages/admin/AdminTools/DigitalIdMigrate");
const PublishLeonards = () => import("@/pages/admin/AdminTools/PublishLeonards");
const Orders = () => import("@/pages/orders/Orders");
const SchoolPortal = () => import("@/pages/schoolportal/Index");

const InvalidContracts = () => import("@/pages/contracts/InvalidContracts");

const Reports = () => import("@/pages/Reports");
const StaffHoursReport = () => import("@/pages/reports/StaffHours");
const EnrollmentsPricelistReport = () => import("@/pages/reports/EnrollmentsPricelist");
const ConsentsReport = () => import("@/pages/reports/Consents");
const SeniorsPhotosExport = () => import("@/pages/reports/SeniorsPhotosExport");
const Agreements = () => import("@/pages/Agreements");
const StudioBackgrounds = () => import("@/pages/studio_backgrounds/StudioBackgrounds");
const MergeManager = () => import("@/pages/merge/MergeManager");
const DiscountsUsed = () => import("@/pages/tools/DiscountsUsed");

const ContractsHome = () =>
	import(/* webpackChunkName: "Other" */ "../pages/admin/Contracts/ContractsHome.vue");

const ContractsReceived = () =>
	import(/* webpackChunkName: "Other" */ "../pages/admin/Contracts/ContractsReceived");

const ContractsUpload = () =>
	import(/* webpackChunkName: "Other" */ "../pages/admin/Contracts/ContractsUpload");
const ContractsRollover = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Contracts/Rollovers/ContractsRollover.vue");
const RolloverContractList = () =>
    import(/* webpackChunkName: "Other" */ "../pages/admin/Contracts/Rollovers/RolloverContractList.vue");


// const ReportSms = () =>
// 	import(/* webpackChunkName: "Other" */ "../pages/admin/ReportSms");

// Routes
const routes = [
    // GUEST ROUTES
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            auth: false,
        },
    },

    {
        path: "/signup",
        name: "signup",
        component: Signup,
        meta: {
            title: "Signup",
            auth: false,
        },
    },

    {
        path: "/invite/:token",
        name: "invite",
        component: UserInvite,
        meta: {
            auth: false,
        },
    },

    {
        path: "/forgot-password",
        name: "forgot-password",
        component: ForgotPassword,
        meta: {
            auth: false,
        },
    },

    // Password Reset ROUTES
    {
        path: "/password-reset/:token",
        name: "password-reset",
        component: PasswordReset,
        meta: {
            auth: false
        },
    },

    {
        path: "/password/create/:token",
        name: "password-create",
        component: PasswordCreate,
        meta: {
            auth: false,
        },
    },

    {
        path: "/event-response",
        name: "event-response",
        component: EventProposalResponse,
        meta: {},
    },

    {
        path: "/upload-data/:link",
        name: "upload-data",
        component: UploadSchoolData,
    },

    // Redirects
    { path: "/page/invalid-schedule-contracts", 	redirect: "/tools/invalid-contracts", },
    { path: "/data-manager", name: "data-manager", 	redirect: "/data-manager/underclass", },

    // MAIN LINKS
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
            auth: true,
        },
    },

    {
        path: "/downloads",
        name: "images.download",
        component: OwncloudImageDownloads,
        meta: {
            auth: true,
            permissions: ['images.download.view']
        },
    },

    {
        path: "/ambassadors",
        name: "ambassadors",
        component: Ambassadors,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    {
        path: "/scholarships",
        name: "scholarships",
        component: Scholarships,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    {
        path: "/profile",
        name: "profile",
        component: Profile,
        meta: {
            auth: true,
        },
    },

    {
        path: "/feedback",
        name: "feedback",
        component: UserFeedback,
        meta: {
            auth: true,
        },
    },

    // {
    //     path: '/military/dashboard',
    //     name: 'dashboard.military',
    //     component: MilitaryDashboard,
    //     meta: {
    //         auth: true
    //     }
    // },

    {
        path: "/sales/report",
        name: "sales.report",
        component: SalesReport,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    // SMS ROUTES
    {
        path: "/sms",
        name: "sms",
        component: SmsCenter,
        meta: {
            auth: true,
            permissions: ['tools.administration']
        },
    },

    // SCHOOL ROUTES
    {
        path: "/school",
        name: "school",
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['school.routes.view']
        },
        children: [
            {
                path: "activity-requests",
                name: "school.activity-requests",
                component: ActivityRequests,
                meta: {
                    auth: true,
                    permissions: ['activity_requests.view']
                },
            },
            {
                path: "activity-requests/new",
                name: "school.activity-requests.new",
                component: NewActivityRequest,
                meta: {
                    auth: true,
                    permissions: ['activity_requests.create']
                },
            },
            {
                path: "business-cards",
                name: "school.business-cards",
                component: BusinessCards,
                meta: {
                    auth: true,
                },
                children: [
                    {
                        path: "details",
                        name: "school.business-card-details",
                        //component: ActivityRequests,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "order-options",
                        name: "school.business-card-options",
                        //component: ActivityRequests,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "payment-details",
                        name: "school.business-card-payment-details",
                        //component: ActivityRequests,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "order-checkout",
                        name: "school.business-card-checkout",
                        //component: ActivityRequests,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "order-confirmation",
                        name: "school.business-card-confirmation",
                        //component: ActivityRequests,
                        meta: {
                            auth: true,
                        },
                    },
                ],
            },
            {
                path: "filmpackage",
                name: "school.filmpackage",
                component: FilmPackageEditor,
                meta: {
                    auth: true,
                },
            },
            {
                path: "id-cards",
                name: "school.id-cards",
                component: IdCards,
                meta: {
                    auth: true,
                },
            },
            {
                path: "reports",
                name: "school.reports",
                component: ReportsLanding,
                meta: {
                    auth: true,
                },
                children: [
                    {
                        path: "summaries",
                        name: "school.reports.summaries",
                        component: Summaries,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "prepaid",
                        name: "school.reports.prepaid",
                        component: PrepaidReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "yearbook",
                        name: "school.reports.yearbook",
                        component: YearbookReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "pictures",
                        name: "school.reports.pictures",
                        component: PicturesReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "retake",
                        name: "school.reports.retake",
                        component: RetakeReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "schedule",
                        name: "school.reports.schedule",
                        component: ScheduleReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "yearbook-approval",
                        name: "school.reports.yearbook-approval",
                        component: YearbookApprovalReport,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "k-11",
                        name: "school.reports.k-11",
                        component: K11Report,
                        meta: {
                            auth: true,
                        },
                    },
                ],
            },
            {
                path: "student-records",
                name: "school.student-records",
                component: StudentRecords,
                meta: {
                    auth: true,
                },
            },
            {
                path: "scheduling",
                name: "school.scheduling",
                component: Scheduling,
                meta: {
                    auth: true,
                },
            },
            {
                path: "upload_file",
                name: "school.upload_file",
                component: SchoolFiles,
                meta: {
                    auth: true,
                },
            },
            {
                path: "upload_students",
                name: "school.upload_students",
                component: StudentFiles,
                meta: {
                    auth: true,
                },
            },
            {
                path: "seniors",
                name: "school.seniors",
                component: Seniors,
                meta: {
                    auth: true,
                    permissions: ['school.seniors.view']
                },
            },
        ],
    },

    // // School Relations
    {
        path: "/relations",
        // name: 'school.relations',
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['school.relations.view']
        },
    },

    // SENIORS
    {
        path: "/appointments",
        name: "appointments",
        component: Appointments,
        meta: {
            auth: true,
        },
    },

    // {
    //     path: "/seniors/report",
    //     name: "sales.report",
    //     component: SalesReport,
    //     meta: {
    //         auth: true,
    //     },
    // },

    // MILITARY ROUTES
    {
        path: "/military/units",
        name: "military.units",
        component: UnitsEditor,
        meta: {
            auth: true,
            permissions: ['military.routes.view']
        },
        children: [],
    },

    // MILITARY ROUTES
    {
        path: "/military",
        // name: 'military',
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['military.routes.view']
        },
        children: [
            {
                path: "",
                name: "military.home",
                component: MilitaryHome,
                meta: {
                    auth: true,
                },
            },
            {
                path: "users",
                name: "military.users",
                component: MilitaryUsers,
                meta: {
                    auth: true,
                    permissions: ['military.btp.users.view']
                },
                children: [

                ],
            },
            {
                path: "graduation-dates",
                name: "military.graduation-dates",
                component: MilitaryGraduationDates,
                meta: {
                    auth: true,
                    permissions: ['military.graduation-dates.view']
                },
                children: [

                ],
            },
            {
                path: "users/new",
                name: "military.btp.users.new",
                component: NewBTPUser,
                meta: {
                    auth: true,
                    permissions: ['military.btp.users.view']
                },
            },
            {
                path: "orders",
                name: "military.orders",
                component: MilitaryOrders,
                meta: {
                    auth: true,
                },
            },
            {
                path: "trainee-search",
                name: "military.trainee-search",
                component: MilitaryTraineeSearch,
                meta: {
                    auth: true,
                    routePermission: true,
                },
            },
            {
                path: "square",
                name: "military.square",
                component: MilitarySquare,
                meta: {
                    auth: true,
                },
            },
            {
                path: "mf13",
                name: "military.mf13",
                component: MilitaryMF13,
                meta: {
                    auth: true,
                },
            },
            // {
            //     path: 'units',
            //     name: 'military.units',
            //     component: MilitaryUnits,
            //     meta: {
            //         auth: true
            //     }
            // },
            // {
            //     path: 'new-unit',
            //     name: 'military.new_unit',
            //     component: NewMilitaryUnit,
            //     meta: {
            //         auth: true
            //     }
            // }
        ],
    },

    // ADMIN ROUTES
    {
        path: "/it/",
        name: "it",
        component: It,
        meta: {
            auth: true,
            permissions: ['it.api-manager.edit']
        },
        children: [
            {
                path: "api-manager",
                name: "it.api-manager",
                component: ItApiManager,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    // ADMIN ROUTES
    {
        path: "/admin/finance/",
        name: "admin.finance",
        component: Finance,
        meta: {
            auth: true,
            permissions: ['finance.orders.edit']
        },
        children: [
            {
                path: "srs",
                name: "admin.finance.srs",
                component: SrsLanding,
                meta: {
                    auth: true,
                },
                children: [
                    {
                        path: "labels",
                        name: "admin.finance.srs.labels",
                        component: SrsLabels,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "labels-request",
                        name: "admin.finance.srs.labels.request",
                        component: SrsLabelsRequest,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "review",
                        name: "admin.finance.srs.review",
                        component: SrsReview,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "review/:contract_num/:batch_num/",
                        name: "admin.finance.srs.entries",
                        component: ReviewEntries,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "entry",
                        name: "admin.finance.srs.entry",
                        component: SrsEntryLanding,
                        meta: {
                            auth: true,
                        },
                        children: [
                            {
                                path: "new",
                                name: "admin.finance.srs.entry.new",
                                component: NewSrsEntry,
                            },
                        ],
                    },
                    {
                        path: "formbuilder",
                        name: "admin.finance.srs.formbuilder",
                        component: SrsFormBuilderLanding,
                        meta: {
                            auth: true,
                        },
                        children: [
                            {
                                path: "new",
                                name: "admin.finance.srs.formbuilder.new",
                                component: NewSrsForm,
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "edit/:form",
                                name: "admin.finance.srs.formbuilder.edit",
                                component: EditSrsForm,
                                meta: {
                                    auth: true,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },

    // CAMPAIGNS ROUTES
    {
        path: "/campaigns/",
        name: "campaigns.home",
        component: Campaigns,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
        children: [
            {
                path: ":campaign_id",
                name: "campaign.edit",
                component: EditCampaigns,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    // PRINTING ROUTES
    {
        path: "/printing/",
        //name: 'printing',
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
        children: [
            {
                path: "batch-id-cards",
                name: "batch-id-cards.view",
                component: PrintBatchIdCards,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    // HUMAN RESOURCES
    {
        path: "/hr/",
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['admin.hr.view']
        },
        children: [
            {
                path: "salphoto",
                name: "salphoto",
                component: Salphoto,
                meta: {
                    auth: true,
                },
            },
            {
                path: "timesheets",
                name: "hr-timesheets",
                component: UserTimesheets,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    {
        path: "/digitalid",
        name: "digitalid",
        component: DigitalIdManager, // () => import(/* webpackChunkName: "IDCards" */  '../pages/digitalid/DigitalIdManager.vue'),
        meta: {
            auth: true,
            permissions: ['digitalid.edit']
        },
    },

    {
        path: "/digital-ids",
        name: "digital-ids",
        component: DigitalIds,
        meta: {
            auth: true,
            permissions: ['digitalid.edit']
        },
    },

    {
        path: "/student-notifications",
        name: "student-notifications",
        component: StudentNotifications,
        meta: {
            auth: true,
            permissions: ['digitalid.edit']
        },
    },

    // LEONARDS TOOLS ROUTES
    {
        path: "/tools/",
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
        children: [
            {
                path: "administration",
                name: "tools.administration",
                component: UserAdministration,
                meta: {
                    auth: true,
                    permissions: ['admin.config.users.edit']
                },
                children: [
                    {
                        path: "user/:user_id?",
                        name: "tools.administration.details",
                        component: UserAdministrationDetails,
                        meta: {
                            auth: true,
                        },
                    },
                    {
                        path: "role/:role_id?",
                        name: "tools.administration.role",
                        component: UserAdministrationRoles,
                        meta: {
                            auth: true,
                        },
                    },
                ],
            },
            {
                path: "carts",
                name: "tools.carts",
                component: Carts,
                meta: {
                    auth: true,
                },
            },
            {
                path: "carts/:cart_id?",
                name: "tools.cart",
                component: CartDetails,
                meta: {
                    auth: true,
                },
            },
            {
                path: "discounts",
                name: "tools.discounts",
                component: Discounts,
                meta: {
                    auth: true,
                },
            },
            {
                path: "request_report",
                name: "tools.request_report",
                component: RequestReports,
                meta: {
                    auth: true,
                },
            },
            {
                path: "film-viewer",
                name: "tools.film_viewer",
                component: FilmViewer,
                meta: {
                    auth: true,
                },
            },
            {
                path: "photo-contest",
                name: "tools.photo_contest",
                component: PhotoContest,
                meta: {
                    auth: true,
                },
            },
            {
                path: "pass-design",
                name: "tools.pass_design",
                component: PassDesign,
                meta: {
                    auth: true,
                },
            },
            {
                path: "noritsu",
                name: "tools.noritsu",
                component: NoritsuJobs,
                meta: {
                    auth: true,
                },
            },
            {
                path: "timesheets",
                name: "tools.timesheets",
                component: Timesheets,
                meta: {
                    auth: true,
                },
            },
            {
                path: "wiki",
                name: "tools.wiki",
                component: Wiki,
                meta: {
                    auth: true,
                },
            },
            {
                path: "wiki/new",
                name: "tools.wiki.new",
                component: NewWiki,
                meta: {
                    auth: true,
                },
            },
            {
                path: "reports/monthly",
                name: "tools.reports.monthly",
                component: MonthlyReport,
                meta: {
                    auth: true,
                },
            },
            {
                path: "reports/label",
                name: "tools.reports.label",
                component: LabelReport,
                meta: {
                    auth: true,
                },
            },
            {
                path: "carousel",
                name: "tools.carousel",
                component: Carousel,
                meta: {
                    auth: true,
                },
            },
            {
                path: "login_images",
                name: "tools.login_images",
                component: LoginImages,
                meta: {
                    auth: true,
                },
            },
            {
                path: "invalid-shipping-addresses",
                name: "tools.invalid-shipping-addresses",
                component: InvalidShippingAddresses,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    {
        path: "/schedule",
        name: "tools.scheduler",
        component: Calendar,
        meta: {
            auth: true,
            permissions: ['scheduling.view']
        },
        children: [
            {
                path: "new-event",
                name: "schedule.new_event",
            },
            {
                path: "search",
                name: "schedule.search",
            },
            {
                path: "event/:id",
                name: "schedule.event",
            },
            {
                path: "people",
                name: "schedule.people_calendar",
            },
        ],
    },

    {
        path: "/schedule/reports",
        name: "schedule.reports",
        component: ScheduleReports,
        meta: {
            auth: true,
            permissions: ['scheduling.view']
        },
    },

    {
        path: "/shipping",
        name: "shipping",
        component: Shipping,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    // {
    //     path: '/schedule/map',
    //     name: 'schedule.map',
    //     component: EventsMap,
    //     meta: {
    //         auth: true
    //     },
    // },

    {
        path: "/admin/config/",
        component: AdminLanding,
        meta: {
            auth: true,
            permissions: ['admin.config.view']
        },
        children: [
            {
                path: "users/new",
                name: "admin.users.new",
                component: NewUser,
                meta: {
                    auth: true,
                },
            },
            {
                path: "roles/new",
                name: "admin.roles.new",
                component: NewRole,
                meta: {
                    auth: true,
                },
            },
            {
                path: "roles/:role_id?",
                name: "admin.roles",
                component: RoleLanding,
                meta: {
                    auth: true,
                },
            },
            {
                path: "permissions",
                name: "admin.permissions",
                component: PermissionLanding,
                meta: {
                    auth: true,
                },
            },
            {
                path: "permissions/new",
                name: "admin.permissions.new",
                component: PermissionNew,
                meta: {
                    auth: true,
                },
            },

            {
                path: "log/activity",
                name: "admin.activity",
                component: ActivityLog,
                meta: {
                    auth: true,
                },
            },

            {
                path: "sidebar",
                name: "admin.sidebar",
                component: SideBarManager,
                meta: {
                    auth: true,
                },
            },

            // {
            // 	path: "route-permissions/:id?",
            // 	name: "admin.route_permissions",
            // 	component: RoutePermissions,
            // 	meta: {
            // 		auth: true,
            // 	},
            // },

        ],
    },

    //schools
    {
        path: "/schools/film_anomalies",
        name: "schools.film_anomalies",
        component: FilmAnomalies,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    //webdesigner
    {
        path: "/webdesigner/",
        name: "webdesigner.index",
        component: WebDesignerIndex,
        meta: {
            auth: true,
            permissions: ['webdesigner.edit']
        },
        children: [
            {
                path: "carousel",
                name: "webdesigner.carousel",
                component: WebDesignerCarousel,
                meta: {
                    auth: true,
                },
            },
            {
                path: "login_images",
                name: "webdesigner.login_images",
                component: WebDesignerLoginImages,
                meta: {
                    auth: true,
                },
            },
        ],
    },

    //webdesigner
    {
        path: "/webdesigner/Config",
        name: "webdesigner.config",
        component: WebsiteConfig,
        meta: {
            auth: true,
            permissions: ['webdesigner.edit']
        },
    },

    //student assignment for teachers
    {
        path: "/student-assignment-url",
        name: "studentassignment.url",
        component: StudentAssignmentUrl,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },
    {
        path: "/student-assignment/:code?/:guid?",
        name: "studentassignment",
        component: StudentAssignment,
        meta: {},
    },

    {
        path: "/owncloud-upload-links",
        name: "owncloud-upload-links",
        component: OwncloudUploadLinks,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    //email list generator
    {
        path: "/email-list-generator",
        name: "emaillistgenerator",
        component: EmailListGenerator,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    //messages
    {
        path: "/messages",
        name: "messages",
        component: Messages,
        meta: {
            auth: true,
            permissions: ['employee.routes.view']
        },
    },

    // dynamic pages
    {
        path: "/page/:page",
        name: "dynamicpage",
        component: DynamicPages,
    },


    {
        path: "/contracts/received",
        name: "contracts.received",
        component: ContractsReceived,
        meta: {
            routePermission: true,
        },
    },

    {
        path: "/contracts/upload",
        name: "contracts.upload",
        component: ContractsUpload,
        meta: {
            routePermission: true,
        },
    },


    // ***** Routes Handled by RoutePermissions Module *****
    {
        path: "/admin/route-permissions",
        name: "admin.route-permissions",
        component: RoutePermissions,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/tools/report-sms",
        name: "tools.report-sms",
        component: ReportSms,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/data-manager/underclass",
        name: "data-manager.underclass",
        component: DataManagerUnderclass,
        meta: {
            routePermission: true,
        },
    },

    {
        path: "/data-manager/seniors",
        name: "data-manager.seniors",
        component: DataManagerSeniors,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/data-manager/data-transfer",
        name: "data-manager.data-transfer",
        component: DataManagerDataTransfer,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/tools/invalid-contracts",
        name: "tools.invalid-contracts",
        component: InvalidContracts,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/tools/reports",
        name: "tools.reports",
        component: Reports,
        meta: { routePermission: true, },
    },
    {
        path: "/tools/reports/staff-hours",
        name: "tools.reports.staff-hours",
        component: StaffHoursReport,
        meta: { routePermission: true, },
    },
    {
        path: "/tools/reports/enrollments-pricelist",
        name: "tools.reports.enrollments-pricelist",
        component: EnrollmentsPricelistReport,
        meta: { routePermission: true, },
    },
    {
        path: "/tools/reports/consents",
        name: "tools.reports.consents",
        component: ConsentsReport,
        meta: { routePermission: true, },
    },
    {
        path: "/tools/reports/seniors-photos",
        name: "tools.reports.seniors-photos",
        component: SeniorsPhotosExport,
        meta: { routePermission: true, },
    },
    {
        path: "/yearbook-manager",
        name: "yearbook-manager",
        component: YearbookManager,
        meta: { routePermission: true },
    },
    {
        path: "/yearbook-manager/rollover",
        name: "yearbook-manager.rollover",
        component: YearbookManagerRollover,
        meta: {
            routePermission: true,
        },
    },
    {
        path: "/tools/student-labels",
        name: "tools.student-labels",
        component: StudentLabels,
        meta: { routePermission: true },
    },
    {
        path: "/admin/tools",
        name: "admin.tools",
        component: AdminTools,
        meta: { routePermission: true },
        children: [
            {
                path: "mysql-audit-triggers",
                name: "admin.tools.mysql-audit-triggers",
                component: MysqlAuditTriggers,
            },
            {
                path: "notify-lists",
                name: "admin.tools.notify-lists",
                component: NotifyLists,
            },
            {
                path: "digital-id-update-photos",
                name: "admin.tools.digital-id-update-photos",
                component: DigitalIdUpdatePhotos,
            },
            {
                path: "digital-id-migrate",
                name: "admin.tools.digital-id-migrate",
                component: DigitalIdMigrate,
            },
            {
                path: "publish-leonards",
                name: "admin.tools.publish-leonards",
                component: PublishLeonards,
            },
        ]
    },
    {
        path: "/merge-manager",
        name: "merge-manager",
        component: MergeManager,
        meta: { routePermission: true },
    },
    {
        path: "/orders",
        name: "orders",
        component: Orders,
        meta: { routePermission: true },
    },
    {
        path: "/schoolportal",
        name: "schoolportal",
        component: SchoolPortal,
        meta: { routePermission: true },
    },
    {
        path: "/photo-feedback",
        name: "photo-feedback",
        component: PhotoFeedback,
        meta: { routePermission: true },
    },
    {
        path: "/agreements",
        name: "agreements",
        component: Agreements,
        meta: { routePermission: true },
    },

    {
        path: "/studio-backgrounds",
        name: "studio-backgrounds",
        component: StudioBackgrounds,
        meta: { routePermission: true },
    },

	{
		path: "/contracts/rollover",
		name: "contracts.rollover",
		component: ContractsRollover,
		meta: {
			routePermission: true,
		},
	},

	{
		path: "/contracts/rollover/:taskId?",
		name: "contracts.rollover.contract-list",
		component: RolloverContractList,
		meta: {
			routePermission: true,
		},
	},

	{
		path: "/military/calendar",
		name: "military.calendar",
		component: MilitaryCalendar,
		meta: {
			routePermission: true,
		},
	},

    {
        path: "/tools/discounts/used",
        name: "tools.discounts.used",
        component: DiscountsUsed,
        meta: { routePermission: true },
    },

    {
        path: "/digital-ids/logs",
        name: "digital-ids.logs",
        component: DigitalIdsLogs,
        meta: { routePermission: true },
    },

    // ERROR ROUTES
    {
        path: "*",
        component: NotFound,
    },
];

const router = new VueRouter({
    history: true,
    mode: "history",
    routes,
});

router.beforeEach(async (to, from, next) => {
    auditRecordRoute(to);
    const publicRoutes = ['login', 'forgot-password', 'password-reset', 'invite']; // only not logged in can see that
    const anyRoutes = ['upload-data']; // anyone (logged in or not) can see that
    Vue.prototype.$auth.load()
        .then(() => {
            const authCheck = Vue.prototype.$auth.check();
            if (anyRoutes.includes(to.name)) {
                next();
            } else if (!authCheck && !publicRoutes.includes(to.name)) {  // not logged in, but the route is in authorized zone
                if (localStorage.getItem('auth-redir') == null) {
                    localStorage.setItem('auth-redir', to.fullPath);
                }
                router.push('/login');
                next();
            } else if (authCheck && publicRoutes.includes(to.name)) { // logged in, but the route is in public zone
                router.push('dashboard');
            }
        });


    // Check if route handled by RoutePermissions
    if (to.matched.some(el => el.meta.routePermission)) {
        await new AxiosRequest().post('check-route-permissions', {route: to.fullPath }).then(response => {
            if (response.success == true) {
                Vue.prototype.$userRoutePermissionActions = response.data;
                next();
            } else {
                router.push('/dashboard');
                next();
            }
        })
    }

    let permissions = [];
    const parentPermissions = to.matched.find(record => record.meta.permissions);

    if (parentPermissions && parentPermissions != undefined) {
        permissions = [...permissions, ...parentPermissions.meta.permissions];
    }

    if (to.meta['permissions'] != undefined && to.meta['permissions']) {
        permissions = [...permissions, ...to.meta.permissions];
    }

    if (permissions.length > 0) {
        const data = {
            permissions: permissions
        }
        await new AxiosRequest().post(`admin/user/permission/show`, data).then(response => {
            if (response.data == false) {
                router.push('/dashboard');
                next();
            }
        })
    }

    next();
});

async function auditRecordRoute(to) {
    await new AxiosRequest().post('audit/route', { url: to.fullPath });
    return;
}

export default router;
